module.exports = __webpack_public_path__ + "static/elemental_gem_water-c848050f35998b153a4698c5f61786d1.jpg";